export interface HubState {
    connecting: boolean;
    offline: boolean;
}

export const initialState: HubState = {
    connecting: false,
    offline: false,
};
